"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResultItemBannerType = exports.ResultIncludeManagementFee = void 0;
var ResultIncludeManagementFee;
(function (ResultIncludeManagementFee) {
    ResultIncludeManagementFee["INCLUDE"] = "I";
    ResultIncludeManagementFee["EXCLUDE"] = "E";
    ResultIncludeManagementFee["UNKNOWN"] = " ";
})(ResultIncludeManagementFee = exports.ResultIncludeManagementFee || (exports.ResultIncludeManagementFee = {}));
var ResultItemBannerType;
(function (ResultItemBannerType) {
    ResultItemBannerType[ResultItemBannerType["Primary"] = 1] = "Primary";
    ResultItemBannerType[ResultItemBannerType["Secondary"] = 2] = "Secondary";
    ResultItemBannerType[ResultItemBannerType["Attribute"] = 3] = "Attribute";
})(ResultItemBannerType = exports.ResultItemBannerType || (exports.ResultItemBannerType = {}));
